(function(){
  'use strict';
  
  function initVideos(root) {
    const vids = root.querySelectorAll('video.bs_lazyvid');

    const loadVid = (v) => {
      if (v.dataset.loaded) return;
      const src = v.dataset.src;
      if (!src) return;

      v.src = src;
      v.dataset.loaded = '1';
      v.load();

      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };

    if (!('IntersectionObserver' in window)) {
      vids.forEach(loadVid);
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        loadVid(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '200px' });

    vids.forEach((v) => io.observe(v));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.best_sellers_intro_sec').forEach(initVideos);
  });

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.best_sellers_intro_sec').forEach(initVideos);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
